import { lazyPage } from '../../utils/lazyPage';

const WNBABestPicksToday = lazyPage(() => import('./BestPicksToday'));
const WNBAmoneyline = lazyPage(() => import('./WNBAmoneyline/WNBAmoneyline'));
const WNBAspread = lazyPage(() => import('./WNBAspread/WNBAspread'));
const WNBAtotal = lazyPage(() => import('./WNBAtotal/WNBAtotal'));

const wnbaRoutes = [
  {
    path: '/wnba/best-picks-today',
    label: 'Best Edges Today',
    renderer: (params = {}) => <WNBABestPicksToday {...params} />,
    hidden: true
  },
  {
    path: '/wnba/moneyline',
    label: 'Moneylines',
    renderer: (params = {}) => <WNBAmoneyline {...params} />
  },
  {
    path: '/wnba/spread',
    label: 'Spreads',
    renderer: (params = {}) => <WNBAspread {...params} />
  },
  {
    path: '/wnba/total',
    label: 'Totals',
    renderer: (params = {}) => <WNBAtotal {...params} />
  }
];

export default wnbaRoutes;